/* Author: AhmadSisfo@gmail.com */
import sc from '@/util/secure'

export default {
    set(key, value) {
        if(value) window.localStorage.setItem(key, sc.enc(value));
    },
    
    get(key) {
        return window.localStorage.getItem(key)? sc.dec(window.localStorage.getItem(key)):null;
    },
    
    remove(key){
        window.localStorage.removeItem(key);
    }
}